import React from "react";

import Dialog from "@material-ui/core/Dialog";
import {
  Box,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@material-ui/core";
import { useAppStyles } from "../../../../App.style";
import { useStyles } from "./style";
import { IconButton } from "../../../../common/components/core";
import { closeBlackIcon, warningIcon } from "../../../../constants/images";
import { AppButton } from "../../../../common/components/AppButton";

export const CreateYourPinDialog = (props) => {
  const { onSetPin, onExit } = props;

  const appClasses = useAppStyles();
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      onClose={onExit}
      aria-labelledby="form-dialog-title"
      maxWidth={"sm"}
      fullWidth
      PaperProps={{ className: appClasses.paperCard }}
    >
      <DialogTitle id="form-dialog-title">
        <div className={appClasses.dialogTitle}>
          <IconButton
            className={appClasses.dialogCloseBtn}
            onClick={onExit}
          >
            <img src={closeBlackIcon} />
          </IconButton>
        </div>
      </DialogTitle>
      <Divider></Divider>
      <Box mt={1} />
      <DialogContent className={appClasses.dialogContent1}>
        <div className={classes.imgWrapper}>
          <img src={warningIcon} />
        </div>
        <div className={classes.imgWrapper}>
          <Typography variant="h6" className={appClasses.text3}>
            Create Your PIN
          </Typography>
          <Box mt={1} />
          <Typography variant="span" className={appClasses.text1}>
            You must set a PIN in order to make ATM withdrawals and card
            transactions.
          </Typography>
        </div>
        <Box mt={4} />
        <AppButton
          contained
          onClick={onSetPin}
          className={`${appClasses.primaryBtn} ${appClasses.width100p}`}
          primary
        >
          Create PIN
        </AppButton>
        <Box mt={2} />
        <AppButton
          variant="text"
          className={`${appClasses.textBtn} ${appClasses.width100p}`}
          onClick={onExit}
        >
          Exit
        </AppButton>
        <Box mt={2} />
      </DialogContent>
    </Dialog>
  );
};
